/*  ============
  Actions for the auth module
  ============

  The actions that are available on the
  auth module.

  */

import * as types from "./mutation-types";
import api from "Resources/util/api";
import helper from "Resources/util/helper";

export const config = ({ commit, state }) => {

    return new Promise((resolve, reject) => {
        if (state.config && state.config.key) {
            resolve(state.config);
        } else {
            api.puller("/api/cache_config")
                .then(response => {
                    let config = helper.receiveResponse(response.data);
                    commit(types.CONFIG, config);
                    resolve(config);
                })
                .catch(error => {
                    helper.flashErrorMessage(error);
                    reject(error);
                })
                .finally(() => {});
        }
    });
};

// localStorage ထဲထိသိမ်း
export const set_list = ({ commit, state }, data) => {

    const now = new Date();

    const item = {
        value: data.value,
        expiry: now.getTime() + state.ttl
    };

    let key = data.key ? data.key : data.url;

    if (!key) {
        console.error(key, data);
    }

    let cache_key = state.generate_key(
        `${key}`,
        data.params,
        state
    );

    commit(types.SET_LIST, { key: cache_key, value: JSON.stringify(item) });

};

export const fresh_location_list = ({ commit }, data) => {
    commit(types.FRESH_LOCATION_LIST, data);
};

// cache list က localStorage ထဲထိမရောက်ဘူး
export const cache_list = ({ commit }, data) => {
    commit(types.CACHE_LIST, data);
};

// ဒါက url အတူတူ param အတူတူကို 2 ခါ pull မဆွဲအောင် ထိန်းတဲ့ဟာ
export const set_pulling_state = ({ commit, state }, info) => {
    commit(types.SET_PULLING_STATE, info);
};

// ဒါက url အတူတူ param အတူတူကို 2 ခါ pull မဆွဲအောင် ထိန်းတဲ့ဟာ
export const set_promise = ({ commit }, promise) => {
    commit(types.SET_PROMISE, promise);
};

export const cache_location = ({ commit, state }, locations) => {

    let locationList = state[state.keys.LOCATION];

    locationList[locations.key] = locations.value;

    commit(types.CACHE_LIST, { key: state.keys.LOCATION, value: locationList });

    // console.log(state[state.keys.LOCATION].length, Object.keys(state[state.keys.LOCATION]));
};

export const routeHistory = ({ commit }, payload) => {
    commit(types.ROUTE_HISTORY, payload);
};

export const labelStatus = ({ commit }, url) => {
    return new Promise((resolve, reject) => {
        api.puller(url)
            .then(response => {
                commit(types.LABEL_STATUS, response.data);
            })
            .catch(error => {
                helper.flashErrorMessage(error);
                // reject(error);
            })
            .finally(() => {
                resolve();
            });
    });

};

export const labelData = ({ commit }, { route, payload }) => {
    return new Promise((resolve, reject) => {
        api.puller(route.url, payload)
            .then(response => {
                commit(types.LABEL_DATA, response.data);
                console.log(payload, response.data);
            })
            .catch(error => {
                helper.flashErrorMessage(error);
                // reject(error);
            })
            .finally(() => {
                resolve();
            });
    })
};

export const setLocale = ({ commit }, payload) => {
    commit(types.SET_LOCALE, payload);
};

export default {
    config,
    set_list,
    cache_list,
    set_pulling_state,
    set_promise,
    cache_location,
    routeHistory,
    labelStatus,
    labelData,
    fresh_location_list,
    setLocale,
};